import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import ErrorIcon from '@atlaskit/icon/core/status-error';
import WarningIcon from '@atlaskit/icon/core/status-warning';
import { token } from '@atlaskit/tokens';

/**
 * @deprecated Use jira/src/packages/jql-builder/with-ai/src/ui/natural-language-to-jql-wrapper/alert-message/index.tsx (AlertMessage) component instead
 */
export const HelperMessage = ({
	appearance,
	children,
	describedBy,
	testId,
}: {
	appearance: 'warning' | 'error';
	children: ReactNode;
	describedBy: string;
	testId?: string;
}) => {
	const Icon = appearance === 'error' ? ErrorIcon : WarningIcon;
	return (
		<Message
			appearance={appearance}
			role="alert"
			aria-describedby={describedBy}
			data-testid={testId}
		>
			<Icon color="currentColor" spacing="spacious" label="" />
			<MessageContent>{children}</MessageContent>
		</Message>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Message = styled.div<{ appearance: 'warning' | 'error' }>({
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	color: (props) =>
		props.appearance === 'error' ? token('color.text.danger') : token('color.text.warning'),
	display: 'flex',
	marginTop: token('space.100'),
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	lineHeight: '24px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const MessageContent = styled.span({
	marginLeft: token('space.050'),
});
